import React from 'react';
type CtaButtonProps = {
  href: string;
  children: React.ReactNode;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  id?: string;
};
export function CtaButton({
  href,
  children,
  className = '',
  onClick,
  id
}: CtaButtonProps) {
  return <a id={id} href={href} onClick={onClick} className={`inline-flex items-center justify-center rounded-xl bg-amber px-5 py-4 text-center font-sans text-[15px] font-bold uppercase leading-tight tracking-[0.2px] text-navy shadow-[0_6px_0_#C48A1E] transition-[transform,box-shadow,background-color] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:bg-amber-hover active:translate-y-1 active:shadow-[0_2px_0_#C48A1E] focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-4 focus-visible:outline-teal motion-reduce:transition-none sm:px-7 sm:text-lg md:py-5 md:text-2xl ${className}`} data-id="element-70" data-mp="cl2eg43xlflh">
      {children}
    </a>;
}